export default {
    login: '/login',

    mypage: '/mypage',
    spotlight: '/profile',
    profile: '/profile',
    profileDocuments: '/profile/documents',

    jobDetailLegacy: '/job', // Fallback for previous job urls, can be removed later
    findcompaniesLegacy: '/companies', // Fallback for previous companies urls, can be removed later

    findjobs: '/jobs',
    jobDetail: '/jobs',
    findcompanies: '/employers',

    masterclasses: '/masterclasses',

    apps: '/apps',
    favorites: '/favorites',

    assessments: '/assessments',
    assessmentCenter: '/center',
    assessmentsRedirect: '/redirect',

    careerPlanning: '/careerplanning',

    courseraLegacy: '/upskill', // Fallback for previous courses urls, can be removed later
    courseraCatalogLegacy: '/upskill/catalog', // Fallback for previous courses urls, can be removed later
    courseraMyCoursesLegacy: '/upskill/my-courses', // Fallback for previous courses urls, can be removed later
    courseraChooseSubscriptionLegacy: '/upskill/join', // Fallback for previous courses urls, can be removed later
    courseraHowToLegacy: '/upskill/how-to', // Fallback for previous courses urls, can be removed later

    coursera: '/courses',
    courseraCatalog: '/courses/catalog',
    courseraMyCourses: '/courses/my-courses',
    courseraChooseSubscription: '/courses/join',
    courseraHowTo: '/courses/how-to',

    account: '/account',
    accountSubscriptions: '/account/billing/subscriptions',
    accountPurchases: '/account/billing/purchases',
    accountInvoices: '/account/billing/invoices',
    accountPayments: '/account/billing/payments',

    plansAndBillingLegacy: '/plansandbilling',

    emailVerification: '/verify',
    recoverUser: '/recover',
    recoverPassword: '/recover-password',

    redirect: '/redirect',

    aboutGPTW: '/about-gptw',

    resourcesLegacy: '/resources/internal', // Fallback for previous internal resources urls, can be removed later
    resources: '/resources',

    toolsLegacy: '/tools',

    calendar: '/calendar',
    book: '/book',
    documents: '/cvupload',
    cvs: '/cvs',
    referrals: '/referrals',

    activateUser: '/activate-user', // Might rename, imported user register flow.

    vfairsLegacy: '/vfairs', // Fallback for previous vfair urls, can be removed later
    vfairsLegacy2: '/vevents', // Fallback for previous vfair urls, can be removed later
    vfairLegacy: '/vfair', // Fallback for previous vfair urls, can be removed later
    vfairLegacy2: '/vevent', // Fallback for previous vfair urls, can be removed later

    vfairs: '/events',
    vfair: '/events',

    chat: '/chat',

    vfairBooths: '/booths',
    vfairDetails: '/details',

    schoolEvents: '/school-events',

    // Legacy routes
    tests: '/tests',
    cute: '/cut-e',
};

export const blacklist = ['/login', '/recover-password', '/redirect', '/activate-user'];
